export type MobileAppPlatform = 'ios' | 'android' | 'unknown';

/** Best-effort client detection for which native store to promote. Not 100% reliable. */
export const getMobileAppPlatform = (): MobileAppPlatform => {
  if (typeof navigator === 'undefined') return 'unknown';

  const ua = navigator.userAgent;
  const isIOS =
    /iPad|iPhone|iPod/i.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  if (isIOS) return 'ios';
  if (/Android/i.test(ua)) return 'android';

  return 'unknown';
};
